export enum LogbookLoadings {
    USER_LIST = 'USER_LIST',
    GET_ACTIVITIES = 'GET_ACTIVITIES'
}